import { appThemes } from '../../env';
import { color, theme } from '../../components/templates/Ui';
export { appThemes };
export const appStyles = {
    inkassier: {
        primary: {
            base: theme.inkassier.primary.base,
            dark: theme.inkassier.primary.dark,
        },
        primaryHover: theme.inkassier.primary.hover,
        secondary: theme.inkassier.secondary.base,
        secondaryHover: theme.inkassier.secondary.hover,
        tertiary: theme.inkassier.tertiary.base,
        tertiaryHover: theme.inkassier.tertiary.hover,
        overlay: theme.inkassier.tertiary.base,
        overlayOpacity: '0.75',
        logo: '/img/inkassier-logo.png',
        fontBase: theme.inkassier.font.base,
        fontHead: theme.inkassier.font.head,
        headingHighlight: theme.inkassier.secondary.base,
        button: {
            base: theme.inkassier.primary.base,
            hover: theme.inkassier.primary.hover,
            color: color.body.base,
            disabled: theme.inkassier.primary.disabled,
        },
        secondaryButton: {
            base: theme.inkassier.secondary.base,
            hover: theme.inkassier.secondary.hover,
            color: color.body.base,
            disabled: theme.inkassier.secondary.disabled,
        },
        tertiaryButton: {
            base: theme.inkassier.tertiary.base,
            hover: theme.inkassier.tertiary.hover,
            color: color.body.base,
            disabled: theme.inkassier.tertiary.disabled,
        },
        input: {
            fontWeight: '600',
        },
        chart: {
            fontSize: 'inherit',
            colors: [
                theme.inkassier.secondary.base,
                theme.inkassier.primary.base,
            ],
        },
        authBg: '/img/inkassier-bg.jpg',
        authBgColor: theme.inkassier.auth.background,
    },
    invoned: {
        primary: {
            base: theme.invoned.primary.base,
            dark: theme.invoned.primary.dark,
        },
        primaryHover: theme.invoned.primary.hover,
        secondary: theme.invoned.secondary.base,
        secondaryHover: theme.invoned.secondary.hover,
        tertiary: theme.invoned.tertiary.base,
        tertiaryHover: theme.invoned.tertiary.hover,
        overlay: theme.invoned.tertiary.base,
        overlayOpacity: '1',
        logo: '/img/invoned-logo.png',
        fontBase: theme.invoned.font.base,
        fontHead: theme.invoned.font.head,
        headingHighlight: theme.invoned.tertiary.base,
        button: {
            base: theme.invoned.primary.base,
            hover: theme.invoned.primary.hover,
            color: color.body.base,
            disabled: theme.invoned.primary.disabled,
        },
        secondaryButton: {
            base: theme.invoned.secondary.base,
            hover: theme.invoned.secondary.hover,
            color: theme.invoned.primary.dark,
            disabled: theme.invoned.secondary.disabled,
        },
        tertiaryButton: {
            base: theme.invoned.tertiary.base,
            hover: theme.invoned.tertiary.hover,
            color: theme.invoned.primary.dark,
            disabled: theme.invoned.tertiary.disabled,
        },
        input: {
            fontWeight: '400',
        },
        chart: {
            fontSize: '14px',
            colors: [theme.invoned.tertiary.base, theme.invoned.primary.base],
        },
        authBg: '/img/invoned-bg.jpg',
        authBgColor: theme.invoned.auth.background,
    },
};
